(function () {
    'use strict';

    angular
        .module('app.customReport',[])
        .factory('customReportService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope)
            {
                var service = {};

                function checkResponse(data) {
                    return data;
                }

                function getMessage(data) {
                    if (data) {
                        return data.message;
                    }
                    return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    }

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (result) {
                            deferred.reject(result);
                        });

                    return deferred.promise;
                }

                function getReportList(selected_company_id, loader)
                {
                    var url_getCustomReportInfo = $rootScope.apiUrl + 'measure/getReportList?selected_company_id=' + selected_company_id;
                    return handleRequest(url_getCustomReportInfo, 'GET', null, loader);
                }

                function restoreReport(params, loader)
                {
                    var url_restoreReport = $rootScope.apiUrl + 'measure/restoreReport';
                    return handleRequest(url_restoreReport, 'POST', params, loader);
                }
                
                service.getReportList = getReportList;
                service.restoreReport = restoreReport;
                return service;
            }
        ])
        .directive('customReportPopover', function($timeout, $compile){
            var linker = function (scope, element, attrs) {
                var content = $compile(element.data('content-compile'))(scope);
                $timeout(function() {
                    element.popover({
                        'html': true,
                        'content': content
                    }).on("show.bs.popover", function(e){
                            $("[rel=popover]").not(e.target).popover("destroy");
                            $(".popover").remove();
                        });
                }, 400);
            }
            return {
                restrict: 'A',
                link: linker
            }
        })
})();
